module.exports = __webpack_public_path__ + "static/ar-img-2-bc06be0224b60f9358da81513612836f.png";